module.exports = __webpack_public_path__ + "static/media/registry-white-bg.571a737d.svg";